import React from 'react'
// components
import ObjectsAndProperties from 'components/PageComponents/Settings/ObjectsAndProperties/Register'
import ObjectsAndPropertiesPageAPI from 'containers/ObjectsAndProperties/Register/layers/API'
import TableManagementProvider from 'containers/Search/layers/BL'

const ObjectsAndPropertiesContainer: React.FC = () => (
  <TableManagementProvider>
    <ObjectsAndPropertiesPageAPI>
      <ObjectsAndProperties />
    </ObjectsAndPropertiesPageAPI>
  </TableManagementProvider>
)

export default ObjectsAndPropertiesContainer
